import { EStringToBoolean } from '../types/EStringToBoolean';

export function stringToBoolean(string: EStringToBoolean): boolean {
  return string === EStringToBoolean.True;
}
